module.exports = __webpack_public_path__ + "img/scroll-old.71eac9f1.svg";